const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
const displayDatePattern = /^(\d{2})-(\d{2})-(\d{4})$/;

const parseDateValue = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return null;
  }

  if (isoDatePattern.test(raw)) {
    const date = new Date(`${raw}T00:00:00`);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const displayMatch = raw.match(displayDatePattern);
  if (displayMatch) {
    const [, day, month, year] = displayMatch;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const toApiDate = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  if (isoDatePattern.test(raw)) {
    return raw;
  }

  const displayMatch = raw.match(displayDatePattern);
  if (displayMatch) {
    const [, day, month, year] = displayMatch;
    return `${year}-${month}-${day}`;
  }

  const parsed = parseDateValue(raw);
  if (!parsed) {
    return raw;
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const toDisplayDateInput = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return "";
  }

  const displayMatch = raw.match(displayDatePattern);
  if (displayMatch) {
    return raw;
  }

  if (isoDatePattern.test(raw)) {
    const [, year, month, day] = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/) || [];
    return year ? `${day}-${month}-${year}` : raw;
  }

  const parsed = parseDateValue(raw);
  if (!parsed) {
    return raw;
  }

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDisplayDate = (value?: string | null) => {
  const raw = String(value || "").trim();
  if (!raw) {
    return "-";
  }

  const date = parseDateValue(raw);
  if (!date) {
    return raw;
  }

  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};
